export const SET_FINANCIAL = "SET_FINANCIAL";
export const SET_FINANCIALS = "SET_FINANCIALS";
export const SET_BANKS = "SET_BANKS";
export const SET_FUNDS = "SET_FUNDS";
export const SET_CASHIERS = "SET_CASHIERS";
